import Decimal from 'decimal.js';
export var num = function num(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return isNaN(Number(value !== null && value !== void 0 ? value : undefined)) ? defaultValue : Number(value);
};

/**
 * @description 四舍五入保留小数位
 * @param number fixed 默认值为 2
 */
export var toFixed = function toFixed(value) {
  var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return num(value).toFixed(fixed);
};
/**
 * @description fixed 保留的小数位数，四舍五入。小于 0 时不处理
 * @param number fixed 默认值为 2
 */
var compute = function compute(action) {
  return function (left, right) {
    var fixed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    var result = Decimal[action](num(left), num(right));
    if (fixed < 0) return result.toNumber();else return result.toFixed(fixed);
  };
};

/**
 * @description 加法
 */
export var add = compute('add');

/**
 * @description 减法
 */
export var sub = compute('sub');

/**
 * @description 乘法
 */
export var mul = compute('mul');

/**
 * @description 除法
 */
export var div = compute('div');